import './tarifsDetailsContenair.css';

import TarifsNavbar from './tarifsNavbar';
import TarifsDetailsText from './tarifsDetailsText';

function TarifsDetailsContenair(){
    return (
        <div className='tarifs-details-contenair'>
            <TarifsDetailsText />
            <TarifsNavbar />
        </div>
    )
}

export default TarifsDetailsContenair;